/** @format */

import React, { useState } from "react";
import { sendModalView } from "../Analytics";
import { Iframe } from "./TitledIframe";
import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";

const ModalIframeCarousel = (props) => {
  const [current, setCurrent] = useState(0);

  const previous = () => {
    if (current > 0) setCurrent(current - 1);
  };
  const next = () => {
    if (current < props.items.length - 1) setCurrent(current + 1);
  };

  const items = props.items;
  if (!items) return null;

  let item = items[current];
  if (!item) {
    item = items[0];
  }

  const trackPath = props.getTrackPath && props.getTrackPath(item);

  if (trackPath) sendModalView(trackPath);

  const itemTitle = props.getTitle && props.getTitle(item);
  let prevLink, nextLink, countOf;
  if (items.length > 1) {
    const atStart = current <= 0;
    const atEnd = current >= props.items.length - 1;
    prevLink = (
      <IconButton
        onClick={previous}
        isDisabled={atStart}
        colorScheme={atStart ? "gray" : "orange"}
        aria-label="previous"
        variant={"link"}
        icon={<ArrowLeftIcon />}
      />
    );

    nextLink = (
      <IconButton
        onClick={next}
        isDisabled={atEnd}
        colorScheme={atEnd ? "gray" : "orange"}
        aria-label="next"
        variant={"link"}
        icon={<ArrowRightIcon />}
      />
    );

    countOf = (
      <React.Fragment>
        {" "}
        ({current + 1} of {props.items.length})
      </React.Fragment>
    );
  }

  return (
    <div className="carouselWrapper">
      <div style={{ height: "2em", textAlign: "center" }}>
        {prevLink}
        {prevLink && " "}
        {itemTitle}
        {countOf}
        {nextLink && " "}
        {nextLink}
      </div>
      <div style={{ height: "calc(100% - 2em)" }}>
        <Iframe src={props.getSrc(item)} />
      </div>
    </div>
  );
};

export default ModalIframeCarousel;
